<template>
  <div class="q3" :class="{ fade: fade }">
    <div class="content">
      <AppBar></AppBar>
      <img
        class="q-index"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q3-head"
      />
      <div class="q-title animate__animated animate__fadeInDown">你的身高</div>
      <div class="q-box">
        <div class="height-content">
          <div class="ruler-content">
            <div class="ruler-container">
              <div class="ruler-left">
                <div class="num">{{ rulerNum }}</div>
                <div class="unit">CM</div>
              </div>
              <MyRulerVer
                class="cs-ruler"
                @post-NumValue="bindRulerNum"
                :NowNum="defaultNum"
                :maxNum="maxNum"
                :minNum="minNum"
              ></MyRulerVer>
            </div>
          </div>
          <div class="person">
            <img class="person-image" :src="genderList[curGender].url" alt="" />
            <div class="dash-line"></div>
          </div>
        </div>
      </div>
      <div class="q-next" v-if="data[index].value !== ''" @click="bindNext"
        >下一步</div
      >
    </div>
  </div>
</template>
<script>
import QBtn from './q-btn.vue'
import AppBar from '../app-bar.vue'
import MyRulerVer from '../my-ruler-ver.vue'
export default {
  components: {
    QBtn,
    MyRulerVer,
    AppBar
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      fade: false,
      curGender: 1,
      rulerNum: 160, // 刻度尺当前值
      defaultNum: 160, //刻度尺默认值
      minNum: 100,
      maxNum: 250,
      genderList: [
        {
          key: 'a',
          value: '男生',
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q1-boy'
        },
        {
          key: 'b',
          value: '女生',
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q1-girl'
        }
      ]
    }
  },
  created() {
    this.$buryPoint('BG_XRWJ_WT3', {})
    this.updateGender()
    this.data[this.index].value = 170
  },
  methods: {
    bindRulerNum(val) {
      this.rulerNum = val
      this.data[this.index].value = val
    },
    updateGender() {
      let curGender = 1
      let gender = this.data[0].value
      this.genderList.map((item, index) => {
        if (item.key == gender) {
          curGender = index
        }
      })
      this.curGender = curGender
    },
    bindNext() {
      if (this.disabled) {
        return
      }
      this.disabled = true
      this.fade = true
      setTimeout(() => {
        this.$emit('next')
      }, 500)
    }
  }
}
</script>
<style lang="scss" scoped>
.q3 {
  opacity: 1;
  transition: opacity 0.5s linear;
  position: relative;
  overflow-y: scroll;
  width: 100%;
  min-height: 100vh;
  background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q1-bg');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  .content {
    overflow: hidden;
  }
  .q-index {
    width: 328px;
    margin: 7px auto 13px;
    height: 61px;
  }
  .q-title {
    text-align: center;
    font-size: 24px;
    font-family: MaoKenTangYuan-beta, MaoKenTangYuan;
    font-weight: 600;
    color: #000000;
    line-height: 34px;
    margin-bottom: 49px;
  }
  .q-box {
    margin-bottom: 59px;
    .height-content {
      padding: 0px 30px;
      display: flex;
      align-items: flex-end;
      justify-content: center;
      .ruler-content {
        flex: 1;
        height: 380px;
        flex-shrink: 0;
        overflow: hidden;
        position: relative;
        .ruler-container {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: flex-start;
          .ruler-left {
            min-width: 60px;
            text-align: center;
            margin-top: 20px;
            margin-right: 18px;
            .num {
              font-size: 30px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: rgba(0, 0, 0, 0.8);
              line-height: 42px;
            }
            .unit {
              font-size: 15px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 600;
              color: rgba(0, 0, 0, 0.8);
              line-height: 21px;
            }
          }
        }
      }
      .person {
        position: relative;
        width: 152px;
        .person-image {
          margin: 0 auto;
          width: 119px;
          height: 345px;
          object-fit: contain;
        }
        .dash-line {
          position: absolute;
          left: 0;
          width: 100%;
          top: 5px;
          border-bottom: 1px dashed rgba(0, 0, 0, 0.4);
          height: 0px;
        }
      }
    }
  }
  .q-next {
    margin: 0 auto 57px;
    text-align: center;
    line-height: 40px;
    font-weight: 600;
    width: 274px;
    height: 42px;
    box-sizing: border-box;
    border-radius: 22px;
    border: 2px solid rgba(0, 0, 0, 0.9);
  }
}
.cs-ruler {
  height: 380px;
}
.fade {
  opacity: 0;
}
@keyframes myrotate {
  0% {
    transform: translateY(100px);
  }
  100% {
    transform: translateY(0px);
  }
}
</style>
